import React, { useState, useEffect, useCallback } from 'react';
import NewsEventCard from '../../Components/NewsEventCard/NewsEventCard';
import Sidebar from '../../Components/Sidebar/Sidebar';
import LoadingSpinner from '../../Components/LoadingSpinner/LoadingSpinner';
import { fetchNews, fetchEvents } from '../../AdminPage/API/AddNewsApi';
import styles from './NewsEventGrid.module.css';

const NewsEventGrid = () => {
  const [filter, setFilter] = useState('all');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);

  const loadItems = useCallback(async () => {
    try {
      setLoading(true);
      let newsData = [];
      let eventsData = [];

      if (filter === 'all' || filter === 'news') {
        newsData = await fetchNews(page);
      }

      if (filter === 'all' || filter === 'events') {
        eventsData = await fetchEvents(page);
      }

      // Combine and sort data
      const combinedData = [...newsData, ...eventsData].sort((a, b) => {
        const dateA = a.type === 'event' ? new Date(a.startDate) : new Date(a.createdAt);
        const dateB = b.type === 'event' ? new Date(b.startDate) : new Date(b.createdAt);
        return dateB - dateA;
      });

      setHasMore(combinedData.length >= 10);
      setItems(prev => page === 1 ? combinedData : [...prev, ...combinedData]);
      setError(null);
    } catch (err) {
      setError('Failed to load news and events');
    } finally {
      setLoading(false);
    }
  }, [filter, page]);

  useEffect(() => {
    loadItems();
  }, [loadItems]);

  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    setPage(1);
    setItems([]);
  };

  if (error) return <div className={styles.error}>{error}</div>;

  return (
    <div className={styles.container}>
      <h1 className={styles.pageTitle}>News and Events</h1>
      <div className={styles.filterButtons}>
        {['all', 'news', 'events'].map((type) => (
          <button
            key={type}
            className={`${styles.filterButton} ${filter === type ? styles.active : ''}`}
            onClick={() => handleFilterChange(type)}
          >
            {type.charAt(0).toUpperCase() + type.slice(1)}
          </button>
        ))}
      </div>
      <div className={styles.content}>
        {items.length > 0 ? (
          <div className={styles.grid}>
            {items.map((item) => (
              <NewsEventCard key={item._id} item={item} />
            ))}
          </div>
        ) : !loading && (
          <div className={styles.noResults}>No news or events found</div>
        )}
        <Sidebar />
      </div>
      {loading && page === 1 && <LoadingSpinner size="large" overlay />}
      {loading && page > 1 && <LoadingSpinner size="medium" />}
      {!loading && hasMore && (
        <button className={styles.loadMoreBtn} onClick={() => setPage(p => p + 1)}>
          Load More
        </button>
      )}
    </div>
  );
};

export default NewsEventGrid;